import { twMerge } from 'tailwind-merge';
import hash from 'object-hash';
import { SlideshowComponent } from './SlideshowComponent';

export const Slideshow = (props) => {
  const slideshowType = props.type;
  const array = props.children.filter((val) => val.type === 'slide');
  // console.log(array);

  let uuid = hash(
    array.map((entry) => {
      const obj = {
        key: entry.key,
        img: entry.props.image,
        position: `object-${entry.props.position}`,
      };
      return obj;
    })
  );
  uuid = `hash-${uuid}`;

  const images = array.map((entry) => {
    const singleSlideClass = twMerge(`object-${entry.props.position}`);
    const image = {
      slide: `${uuid}-${entry.key}`,
      url: entry.props.image,
      position: singleSlideClass,
      alt: entry.props.alt,
    };
    return image;
  });

  const contents = array.map((entry) => {
    const fullArray = entry.props.children.filter((val) => val.type === 'div');
    const contentArray = fullArray[0].props.children;
    let contentItems = [];
    if (Array.isArray(contentArray)) {
      const cleanContent = contentArray.filter((val) => val !== '\n');
      cleanContent.map((val) =>
        val.props
          ? contentItems.push(val.props.children)
          : contentItems.push(val)
      );
    } else {
      contentItems = contentArray.split('\n').filter((n) => n);
    }

    const content = {
      slide: `${uuid}-${entry.key}`,
      content: contentItems,
    };
    return content;
  });

  return SlideshowComponent(images, contents, slideshowType, uuid);
};
